import { i18n } from "../../i18n";
import { PrimaryButton } from "../Buttons/PrimaryButton";
import { closeModal } from "./Modal";

export const NoAdditionalDutiesInformationModalContent = () => {
  return (
    <>
      <article className="tw:px-4">
        <h2>{i18n("no-duties-modal.title")}</h2>
        <p>{i18n("no-duties-modal.description.1")}</p>
        <hr class="tw:border-0 tw:border-b tw:border-fruugo-border-control tw:my-4 tw:sm:hidden" />
        <div class="tw:flex tw:justify-center tw:sm:justify-start">
          <a
            href="/help/detail/customs-charge"
            target="_blank"
            className="tw:underline tw:hover:no-underline tw:focus-visible:ring-2 tw:focus-visible:ring-offset-2 tw:focus-visible:ring-fruugo-blue-secondary"
          >
            {i18n("duties-modal.learn-more")}
          </a>
        </div>
      </article>
      <footer className="tw:bg-white tw:border-none tw:text-right tw:p-4 tw:rtl:text-left">
        <PrimaryButton
          onClick={() => closeModal()}
          variant="solid"
          cssClass="tw:w-full tw:sm:w-auto"
        >
          {i18n("modal.duties-and-taxes.button")}
        </PrimaryButton>
      </footer>
    </>
  );
};
